import React from 'react';
import './Loader.css';

const Loader = ({ message = "Cargando ...", fullScreen = false, size = 200 }) => {
  const loaderContent = (
    <div className="custom-loader-container" style={{ width: size, height: size }}>
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1080 1080"
        style={{ enableBackground: 'new 0 0 1080 1080' }}
        xmlSpace="preserve"
        width="100%"
        height="100%"
      >
        <style type="text/css">
          {`
            .st0{fill:#2F4F88;}
            .st1{fill:#616160;}
            .st2{fill:#EC6B4B;}
            .st3{fill:#A8A7A7;}
            .st4{fill:#F18B78;}
            .st5{fill:#20345F;}
            .st6{fill:#FFFFFF;}
          `}
        </style>
        <g>
          <path
            className="st1 svg-elem-1"
            d="M799.95,358.46c23.68,10.22,44.43,24.26,62.27,42.1c17.83,17.83,31.86,38.72,42.1,62.71
            c10.22,23.97,15.35,49.4,15.35,76.3c0,27.48-5.12,53.06-15.35,76.74c-10.24,23.68-24.27,44.58-42.1,62.71
            c-17.84,18.12-38.59,32.3-62.27,42.53c-23.68,10.22-49.26,15.35-76.74,15.35H525.88v-78.06h197.33c16.36,0,31.71-3.07,46.04-9.21
            c14.32-6.14,26.89-14.62,37.71-25.43c10.81-10.83,19.29-23.54,25.43-38.15c6.14-14.62,9.21-30.12,9.21-46.48
            c0-16.37-3.07-31.72-9.21-46.04c-6.14-14.33-14.62-26.9-25.43-37.71c-10.83-10.82-23.39-19.29-37.71-25.43
            c-14.33-6.14-29.68-9.21-46.04-9.21H525.88v-78.06h197.33C750.68,343.11,776.27,348.22,799.95,358.46z"
          />
          <path
            className="st2 svg-elem-2"
            d="M296.91,721.54c-23.68-10.22-44.43-24.26-62.27-42.1c-17.83-17.83-31.86-38.72-42.1-62.71
            c-10.22-23.97-15.35-49.4-15.35-76.3c0-27.48,5.12-53.06,15.35-76.74c10.24-23.68,24.27-44.58,42.1-62.71
            c17.84-18.12,38.59-32.3,62.27-42.53c23.68-10.22,49.26-15.35,76.74-15.35h197.33v78.06H373.65c-16.36,0-31.71,3.07-46.04,9.21
            c-14.32,6.14-26.89,14.62-37.71,25.43c-10.81,10.83-19.29,23.54-25.43,38.15c-6.14,14.62-9.21,30.12-9.21,46.48
            c0,16.37,3.07,31.72,9.21,46.04c6.14,14.33,14.62,26.9,25.43,37.71c10.83,10.82,23.39,19.29,37.71,25.43
            c14.33,6.14,29.68,9.21,46.04,9.21h197.33v78.06H373.65C346.18,736.89,320.59,731.78,296.91,721.54z"
          />
          <circle className="st2 svg-elem-3" cx="572.08" cy="382.14" r="39.03" />
          <circle className="st3 svg-elem-4" cx="572.08" cy="382.14" r="39.03" />
          <circle className="st4 svg-elem-5" cx="572.08" cy="697.86" r="39.03" />
        </g>
      </svg>
      {message && (
        <p className="loader-message mt-3" style={{ fontSize: "18px", fontWeight: "500", color: "#333" }}>
          {message}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        {loaderContent}
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center p-5">
      {loaderContent}
    </div>
  );
};

export default Loader;

